import { fetchAuthSession } from 'aws-amplify/auth';

type RestAuthTokenProvider = () => Promise<string | null>;

/**
 * Bearer-token source for the non-GraphQL HTTP clients in this lib (clientHttp,
 * browser error reporting) and for @bakerweb/baker-services. Defaults to the
 * Cognito id token so the client app keeps working unchanged; apps that
 * authenticate with another IdP (e.g. apps/baker on Entra/MSAL) call
 * setRestAuthTokenProvider() at bootstrap to supply their own token.
 */
let overrideProvider: RestAuthTokenProvider | null = null;

export const setRestAuthTokenProvider = (provider: RestAuthTokenProvider) => {
  overrideProvider = provider;
};

export const getRestAuthToken = async (): Promise<string | null> => {
  if (overrideProvider) {
    try {
      return await overrideProvider();
    } catch {
      return null;
    }
  }
  try {
    const session = await fetchAuthSession();
    return session?.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
};
